module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corona_borealis/crb_vis-0a430d477cf9c734837552f580256360.jpg";